import { Route, Routes } from "react-router-dom";
import PartstechCatalog from "../child_components/PartstechCatalog";
import PartstechQuotes from "../child_components/PartstechQuotes";
import PartstechOrders from "../child_components/PartstechOrders";
import PartstechInventory from "../child_components/PartstechInventory";

function OrderService() {

    return (
        <div>
            <Routes>
                <Route path='/catalog' element={<PartstechCatalog />} />
                <Route path='/quotes' element={<PartstechQuotes />} />
                <Route path='/orders' element={<PartstechOrders />} />
                <Route path='/inventory' element={<PartstechInventory />} />
            </Routes>
        </div>
    )
}

export default OrderService;